import * as React from 'react';
import { Datagrid, DateField, List, TextField } from 'react-admin';
import { CustomTitle } from '../../components/CustomTitle';
import { IndexField } from '../../components/IndexField';

export const DeviceList = (props: unknown) => (
  <List sort={{ field: 'token', order: 'ASC' }} title={<CustomTitle />} {...props}>
    <Datagrid rowClick="edit">
      <IndexField label="#" sortable={false} />
      <TextField source="token" />
      <TextField source="id" />
      <DateField source="createdate" showTime />
      <DateField source="lastupdate" showTime />
      <TextField source="dev" />
      <TextField source="dev2" />
      <TextField source="dev3" />
      <TextField source="dev4" />
    </Datagrid>
  </List>
);
